// Shared golden-ratio target storage. The formula-sheet card and the full
// Golden Ratio screen both edit the same targets; localStorage is the single
// copy, so the two views can never disagree. Values are kept as strings so an
// input can be emptied mid-edit. Defaults are Joana's spec: 25/55/20.

export type TargetBucket = "hydro" | "isolate" | "pulse";
export type GrTargets = Record<TargetBucket, string>;

export const GR_TARGET_KEY = "goldenRatio.targets";
export const GR_DEFAULT_TARGETS: GrTargets = { hydro: "25", isolate: "55", pulse: "20" };

export function loadGrTargets(): GrTargets {
  try {
    const raw = localStorage.getItem(GR_TARGET_KEY);
    if (raw) {
      const p = JSON.parse(raw);
      const pick = (k: TargetBucket) =>
        typeof p[k] === "string" && p[k].length <= 8 ? p[k] : GR_DEFAULT_TARGETS[k];
      return { hydro: pick("hydro"), isolate: pick("isolate"), pulse: pick("pulse") };
    }
  } catch (e) {
    /* corrupt or unavailable storage — fall through to defaults */
  }
  return { ...GR_DEFAULT_TARGETS };
}

export function saveGrTargets(t: GrTargets): void {
  try {
    localStorage.setItem(GR_TARGET_KEY, JSON.stringify(t));
  } catch (e) {
    /* storage full — targets still work for this session */
  }
}

export function grTargetNumbers(t: GrTargets): Record<TargetBucket, number> {
  return {
    hydro: parseFloat(t.hydro) || 0,
    isolate: parseFloat(t.isolate) || 0,
    pulse: parseFloat(t.pulse) || 0,
  };
}

export function grTargetsAreDefault(t: GrTargets): boolean {
  return (
    (parseFloat(t.hydro) || 0) === 25 &&
    (parseFloat(t.isolate) || 0) === 55 &&
    (parseFloat(t.pulse) || 0) === 20
  );
}
